var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", { staticClass: "text-center" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loading
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loading
      ? _c(
          "div",
          [
            _c("div", { staticClass: "select text-center" }, [
              _c("h3", { staticClass: "text-primary" }, [
                _vm._v("Select your customer"),
              ]),
            ]),
            _c("b-form-select", {
              attrs: { options: _vm.optionsCustomer },
              on: {
                change: function ($event) {
                  return _vm.customerSelected()
                },
              },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }